import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Input,
  ReactSelect,
} from "@anchor/react-components/dist/lib/components";
import { RunModel, listModel } from "../../Model";
import { getAPI, postAPI } from "../../../../Services/APIservices";
import { toastEmitter } from "@anchor/react-components";
interface IPROPS {
  isModal: boolean;
  onClose: () => void;
  simulationData: RunModel;
  reRender: () => void;
  optimizationType: listModel[];
}
const SimulationDuplicate = ({
  isModal,
  onClose,
  simulationData,
  reRender,
  optimizationType,
}: IPROPS) => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);

  const [selectedService, setSelectedService] = useState<listModel[]>();
  const [serviceIdsList, setServiceIdsList] = useState<any>();
  const [serviceLists, setServiceLists] = useState<listModel[]>([]);

  const [defaultServiceValue, setDefaultServiceValue] = useState<any>();
  const [selectedIdlevessel, setSelectedIdlevessel] = useState<listModel[]>([]);
  const [idleVesselsList, setIdelVesselsList] = useState<any>();
  const [idleVesselError, setIdleVesselError] = useState<string | null>(null);
  const [segmentUp, setSegmentUp] = useState<string>("");
  const [segmentDown, setSegmentDown] = useState<string>("");

  const getServiceList = (res, defaultService) => {
    const serviceIds = simulationData?.serviceIds?.split(",");
    const listedData: listModel[] = res.filter((item: any) => {
      return serviceIds.includes(item.value.toString());
    });
    const filterData = listedData?.map((item) => {
      return {
        label: item.label,
        value: item.value,
        isDisabled: defaultService?.some((selected) =>
          selected.value === item.value
        ),
      };
    });
    
    filterData.sort(function(a,b){return b.isDisabled-a.isDisabled});
    setSelectedService(filterData);
    setServiceIdsList(listedData?.map((item) => item.value))
  };

  const getIdleVesselList = (res, defaultService) => {
    const idlevessels = simulationData?.idleVessels
    ? simulationData.idleVessels.split(",").map((x) => x.trim())
    : [];
  
    const listedData: listModel[] = res.filter((item: any) =>
      idlevessels.includes(item.label?.toString())
    );
  
    const filterData = listedData?.map((item) => ({
      label: item.label,
      value: item.value,
      isDisabled: defaultService?.some(
        (selected) => selected.value === item.value
      ),
    }));
  
    filterData.sort((a, b) => b.isDisabled - a.isDisabled);
    setSelectedIdlevessel(filterData);
    setIdelVesselsList(listedData?.map((item) => item.value));
  };

  const handleRequest = async () => {

    setIdleVesselError(null); // reset
    if (simulationData?.optimizationType === "Vessel-Out" && selectedIdlevessel.length === 0) 
      {
      setIdleVesselError("Please select at least one idle vessel.");
      return;
    }

    setIsBtnDisabled(true);
    const optimizationTypeId= optimizationType.find((item)=>item.label===simulationData?.optimizationType)?.value;

    const payload = {
      serviceIds: serviceIdsList,
      imos: [Number(simulationData?.imos) ?? ""],
      requestName: "",
      OptimizationId: optimizationTypeId,
      idleVessels: selectedIdlevessel.map((item) => item.value),
      segmentUp: segmentUp === "" ? null : Number(segmentUp),
      segmentDown: segmentDown === "" ? null : Number(segmentDown),
      
    };

    const response = await postAPI(
      "simulation-api/simulation/SaveSimulationRequestAsync",
      payload
    );
    if (response === true) {
      toastEmitter(
        {
          className: "customClassName",
          title: "Request submitted successfully",
        },
        { type: "success" }
      );
      reRender();
      setIsBtnDisabled(false);
    } else {
      toastEmitter(
        {
          className: "customClassName",
          title: "Something went wrong",
        },
        { type: "error" }
      );
      setIsBtnDisabled(false);
    }
    oncloseModal();
  };
  const handleServiceList = (e: any) => {
   
    if (simulationData?.optimizationType === "Vessel-Out") {
      if (e.length == 0) {
        setSelectedService(defaultServiceValue);
      } else {
        const newSelectdedValue: any = [...e];
        setSelectedService(newSelectdedValue);
      }
    } else {
      setSelectedService(e);
    }
    const serviceID = e?.map((item) => item.value);
    setServiceIdsList(serviceID);
  };

  const handleIdleVesselList = (e: any) => {
    if (simulationData?.optimizationType === "Vessel-Out") {
      if (e.length === 0) {
        const newSelectedValue: any = [...e];
        setSelectedIdlevessel(newSelectedValue);
      } else {
        const newSelectedValue: any = [...e];
        setSelectedIdlevessel(newSelectedValue);
      }
    } else {
      setSelectedIdlevessel(e);
    }
  };
  


  const getActiveSelectedService = async (imoNumber: any) => {
    const response = await getAPI(`simulation-api/simulation/GetCurrentServiceForVessel/${imoNumber}`);
    if (response) {
      const res = response?.map((item) => {
        return {
          label: item.label,
          value: item.value,
        };
      });
      setDefaultServiceValue(res);
      getServiceListApI(res);
    }
  };

  const getIdleVesselListApI = async (defaultIdelVessel?: any) => {
    const response = await getAPI(`simulation-api/simulation/GetIdleVessels`);
    if (response) {
      const res = response?.map((item) => {
        return {
          label: item.label,
          value: item.value,
        };
      });
      
      getIdleVesselList(res, defaultIdelVessel);
      setIdelVesselsList(res);
    }
  };

  const getServiceListApI = async (defaultService?: any) => {
    const response = await getAPI(`dtco-api/dtcosummary/GetActiveServicesAsync/${simulationData?.optimizationType}`);
    if (response) {
      const res = response?.map((item) => {
        return {
          label: item.label,
          value: item.value,
        };
      });
      getServiceList(res, defaultService);
      setServiceLists(res);
    }
  };
  const loadSegmentMapping = async () => {
    try {
      const response: any = await getAPI('dtco-api/dictionary/GetSegmentMapping');
      if (response) {
        if ((simulationData?.segmentUp === undefined || simulationData?.segmentUp === null) && response.segmentUp !== undefined && response.segmentUp !== null) {
          setSegmentUp(String(response.segmentUp));
        }
        if ((simulationData?.segmentDown === undefined || simulationData?.segmentDown === null) && response.segmentDown !== undefined && response.segmentDown !== null) {
          setSegmentDown(String(response.segmentDown));
        }
      }
    } catch {
      // ignore errors
    }
  };
  useEffect(() => {
    if (isModal) {
      setIsShowModal(isModal);
      // initialize segmentUp/Down: prefer values from simulationData, else fetch mapping
      if (simulationData?.segmentUp !== undefined && simulationData?.segmentUp !== null) {
        setSegmentUp(String(simulationData.segmentUp));
      }
      if (simulationData?.segmentDown !== undefined && simulationData?.segmentDown !== null) {
        setSegmentDown(String(simulationData.segmentDown));
      }
      if ((simulationData?.segmentUp === undefined || simulationData?.segmentUp === null) || (simulationData?.segmentDown === undefined || simulationData?.segmentDown === null)) {
        loadSegmentMapping();
      }
      if (simulationData?.optimizationType === "Vessel-Out") {
        getActiveSelectedService(simulationData?.imos);
        getIdleVesselListApI();
      } else {
        getServiceListApI();
        getIdleVesselListApI();
      }

    }
    setIdleVesselError(null);
  }, [isModal]);

  const oncloseModal = () => {
    setIsShowModal(false);
    onClose();
  };
  return (
    <Modal
      actions={{
        primaryAction: (
          <Button label="Request" disabled={isBtnDisabled} onClick={handleRequest} fit="small" />
        ),
        secondaryAction: (
          <Button
            label="Cancel"
            fit="small"
            variant="outlined"
            onClick={oncloseModal}
          />
        ),
      }}
      heading="Do you want to change the list of services before running the request ?"
      showCloseIcon
      onClose={oncloseModal}
      className="DuplicateModal"
      width="560px"
      height="500px"
      open={isShowModal}
      backdropcloseactiondisabled
    >
      <div className="DuplicateModal">
        <div>
          <Input
            id="duplicateVessel"
            value={simulationData?.vesselName}
            disabled
          />
        </div>
        <div className="ServiceList">
          <ReactSelect
            className={`react-select ${simulationData?.optimizationType}`}
            closeMenuOnSelect
            errorMessage="This is error message"
            fit="medium"
            id="selectservice"
            isClearable
            isSearchable
            onChange={(e) => {
              handleServiceList(e);
            }}
            label="Service Names(s)"
            name="serviceList"
            options={serviceLists}
            orientation="vertical"
            placeholder="Select a Service from the list"
            required
            isMulti
            value={selectedService}
            variant="default"
            width={100}
          />
        </div>
        
        <div className="IdleVesselList" style={{ marginTop: '18px' }}>
        <ReactSelect
            className={`react-selects ${simulationData?.optimizationType}`}
            closeMenuOnSelect
            fit="medium"
            id="selectidlevessel"
            isClearable
            isSearchable
            onChange={(e) => {
              setIdleVesselError(null);
              handleIdleVesselList(e);
            }}
            required={simulationData?.optimizationType === "Vessel-Out"}
            label="Idle Vessel(s)"
            name="idleVesselList"
            options={idleVesselsList}
            orientation="vertical"
            placeholder="Select idle vessel"
            isMulti
            value={selectedIdlevessel}
            variant="default"
            width={100}
            errorMessage={idleVesselError ?? undefined}
          />
          {idleVesselError && (
    <p style={{ color: "red", marginTop: "5px" }}>{idleVesselError}</p>
  )}
        </div>
        <div className="SegmentUpDown" style={{ marginTop: '18px' }}>
          <label className="form-label mb-1">Segment Up / Down</label>
          <div className="d-flex align-items-center" style={{ gap: '8px' }}>
            <div style={{ width: '70px' }}>
              <Input
                id="segmentUp"
                type="number"
                fit="medium"
                variant="default"
                placeholder="Up"
                min={0}
                max={20}
                step={1}
                value={segmentUp}
                onChange={(e: any) => setSegmentUp(String((e && e.target && e.target.value) ?? e))}
              />
            </div>
            <span>/</span>
            <div style={{ width: '70px' }}>
              <Input
                id="segmentDown"
                type="number"
                fit="medium"
                variant="default"
                placeholder="Down"
                min={0}
                max={20}
                step={1}
                value={segmentDown}
                onChange={(e: any) => setSegmentDown(String((e && e.target && e.target.value) ?? e))}
              />
            </div>
          </div>
        </div>
              
      </div>
    </Modal>
  );
};
export default SimulationDuplicate;
